import { Button, Card, Form, Input, Typography, Layout, message } from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useState } from "react";
import axios from "../../services/axiosInstance";
import { RESET_PASSWORD } from "../../services/apiEndPoints";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;
const { Content } = Layout;

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { email: any }) => {
    setLoading(true);
    try {
      const response = await axios.post(RESET_PASSWORD, {
        memberEmail: values.email,
      });

      const data = response.data;

      if (response.status !== 200) {
        throw new Error(data.message || "Something went wrong");
      }

      message.success("Password reset link sent to your email");
    } catch (error) {
      message.error(
        error instanceof Error ? error.message : "Failed to send reset link"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="login-layout">
      {/* Decorative Side */}
      <div className="login-decor">
        <div className="decor-circle decor-1" />
        <div className="decor-circle decor-2" />
        <div className="decor-circle decor-3" />

        <div className="decor-content">
          <div className="decor-logo">
            <img
              src="/logo.png"
              alt="Logo"
              style={{ height: 48, width: 48, objectFit: "contain" }}
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          </div>
          <Title level={2} style={{ color: "#fff", marginBottom: 8 }}>
            Access Warehousing
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: 15 }}>
            Document management made simple
          </Text>
        </div>
      </div>

      {/* Forgot Password Form */}
      <Content className="login-content">
        <Card className="login-card" styles={{ body: { padding: "32px 28px" } }}>
          <div style={{ marginBottom: 24 }}>
            <Title level={3} style={{ marginBottom: 4 }}>
              Reset Password
            </Title>
            <Text type="secondary">
              Enter your email address and we'll send you a reset link.
            </Text>
          </div>

          <Form layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Enter your email address" },
                { type: "email", message: "Enter a valid email" },
              ]}
            >
              <Input
                prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
                placeholder="you@example.com"
                size="large"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 12 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
                style={{ height: 44, fontWeight: 600 }}
              >
                Send Reset Link
              </Button>
            </Form.Item>

            <div style={{ textAlign: "center" }}>
              <Link to="/login">
                <Button type="link" icon={<ArrowLeftOutlined />} style={{ padding: 0 }}>
                  Back to Sign In
                </Button>
              </Link>
            </div>

            <Text
              type="secondary"
              style={{
                display: "block",
                textAlign: "center",
                marginTop: 24,
                fontSize: 12,
              }}
            >
              &copy; {new Date().getFullYear()} Access Warehousing
            </Text>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
}
